
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Certificate styling utility function (similar to cn but with different name for certificate-specific styles)
export function cnvs(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats CEU hours to one decimal place maximum
 * This prevents display of excessive decimal places (like 2.40000000004)
 * and rounds to the nearest 0.1
 * 
 * @param hours The CEU hours value to format
 * @returns Formatted string with at most one decimal place
 */
export function formatCEU(hours: number | string): string {
  // Convert string to number if needed
  const numericHours = typeof hours === 'string' ? parseFloat(hours) : hours;
  
  // Handle invalid input
  if (isNaN(numericHours)) {
    return '0.0';
  }
  
  // Round to 1 decimal place and remove trailing zeros
  const rounded = Math.round(numericHours * 10) / 10;
  
  // Return as string with appropriate format
  return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(1);
}
